import { AppDispatch, GetState, RootState } from '../store';
import { Account } from '../../types/account';
import { changeSessionState, selectSessionId } from '../slices/session.slice';
import { reportError } from '../slices/error.slice';
import { FinishedState, SessionState } from '../../types/session';
import { ChooseAccountData } from '../../services/interfaces/session.interface';
import { callbackRegistry } from '../../features/session/callback-registry';
import { sdkCallbacks } from '../../features/session/sdk-callbacks';
import { getSessionService } from '../../services/service.factory';

export const chooseAccount = (account: Account) => {
	return async (dispatch: AppDispatch, getState: GetState): Promise<void> => {
		try {
			const state = getState();
			const sessionId = getSessionId(state);
			const data: ChooseAccountData = { accountId: account.id };
			const nextState = await getSessionService(state.configuration.bankIntegrationVendor).chooseAccount(
				sessionId,
				data
			);
			if (isFinishedState(nextState)) {
				executeOnFinishedCallbacks();
			}

			dispatch(changeSessionState(nextState));
		} catch (error: any) {
			dispatch(
				reportError({
					type: 'TECHNICAL',
					reason: error
				})
			);
		}
	};
};

const getSessionId = (state: RootState) => {
	const sessionId = selectSessionId(state);
	if (!sessionId) throw new Error('Session id not defined on choose bank action');
	return sessionId;
};

const isFinishedState = (state: SessionState): state is FinishedState => {
	return state.status === 'FINISHED';
};

const executeOnFinishedCallbacks = () => {
	try {
		callbackRegistry.retrieve('onFinished')();
		sdkCallbacks.execute('onFinished');
	} catch (error: any) {}
};
